const AuditList = () => import('./auditList');
const SettledList = () => import('./settledList');
// const AuditDetail = () => import('./auditDetail');
// const SettledDetail = () => import('./settledDetail');
const OrderList = () => import('./orderList');

const routes = [
  {
    path: '/dboss/auditManage', component: AuditList,
    name: '入驻审核管理'
  },
  // {
  //   path: '/dboss/auditDetail', component: AuditDetail,
  //   name: '入驻审核详情'
  // },
  {
    path: '/dboss/settledManage', component: SettledList,
    name: '入驻店铺管理'
  },
  // {
  //   path: '/dboss/settledDetail', component: SettledDetail,
  //   name: '入驻店铺详情'
  // }
  {
    path: '/dboss/orderList', component: OrderList,
    name: '服务订单列表'
  }, 
]

export default routes;